import { Grid } from "@mui/material";
import { Deal } from "../../api";
import CustomAutocomplete from "./CustomAutocomplete";
import { getDealLabel } from "../../utilities/utils";

interface Props {
	deals: Deal[];
	selectedDeals: Deal[];
	loading: boolean;
	setSelectedDeals: (deals: Deal[]) => void;
}

export default function DealSelectionAutocomplete(props: Props) {
	return (
		<Grid item xs={12}>
			<CustomAutocomplete
				loading={props.loading}
				options={props.deals.sort((a, b) => {
					const aLabel = getDealLabel(a);
					const bLabel = getDealLabel(b);
					return aLabel.localeCompare(bLabel);
				})}
				optionFormatter={(option) => getDealLabel(option) ?? ""}
				selectedOption={props.selectedDeals[0] ?? null}
				onChange={(value) => {
					props.setSelectedDeals(value ? [value] : []);
				}}
				label="Select the most common sampling configuration you need right now"
			/>
		</Grid>
	);
}
